module.exports = __webpack_public_path__ + "img/iriomote_10.98f92f3c.jpg";